import * as React from "react"

class EnquiryForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formSubmitted: false,
      message: "",
      dropdown:""

    }
    
  }
  componentDidMount() {
    document.querySelector("form").addEventListener("submit", this.handleSubmit)
    if(this?.props?.linkState?.productName){
      this.setState({message:`I'd like to enquire about `+this.props.linkState.productName})
      this.setState({dropdown:true}) 
    }
   
  }
  

  handleSubmit = e => {

    e.preventDefault()
    let myForm = document.getElementById("contact")
    let formData = new FormData(myForm)
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => {
        const form = document.querySelector("form")
        form.classList.add("fade-out")
        setTimeout(() => {
          this.setState({ formSubmitted: true },()=>{
            const thankYou = document.querySelector("#thank-you")
            setTimeout(()=>{
              thankYou.classList.add("fade-in-thank-you")
            },100)
           
          })
        }, 1250)
      })
    .catch(error => console.error(error))
    document.querySelector("form").addEventListener("submit", this.handleSubmit);
  }

  render() {
    const formSubmitted = this.state.formSubmitted
    const solicitors = this.props.solicitors || []
    
    if(!formSubmitted){
    return (
        <form method="POST" data-netlify="true" netlify-honeypot="bot-field" id="contact" className="form-section flex flex-wrap mr20 m-m0 m-p20 t-pl20">
            <p style={{ display: "none" }}>
                <label>
                    Don't fill this out: <input name="bot-field" />
                </label>
            </p>
            
            <input type="hidden" name="form-name" value="contact" />

            <div className="w-50 m-100 flex flex-wrap">
                <label className="uppercase mb10" htmlFor="First Name">First Name *</label>
              <input name="First Name" type="text" required className="w-100 input mr20 m-m0"/>
            </div>

            <div className="w-50 m-100 flex flex-wrap m-mt20">
                <label className="uppercase mb10" htmlFor="Last Name">Last Name *</label>
                <input name="Last Name" type="text" required className="w-100 input"/>
            </div>

            <div className="w-50 m-100 flex flex-wrap mt20">
                <label className="uppercase mb10" htmlFor="Email">Email *</label>
                <input name="Email" required type="text" className="w-100 input mr20 m-m0"/>
            </div>

            <div className="w-50 m-100 flex flex-wrap mt20">
                <label className="uppercase mb10" htmlFor="Phone">Phone</label>
                <input name="Phone" type="text" className="w-100 input"/>
            </div>

            <div className="w-50 m-100 flex flex-wrap mt20">
                <label className="uppercase mb10" htmlFor="Office">Preferred Office</label>
                <div className="dropdown-wrapper w-100 mr20 m-m0">
                    <select name="Office" className="dropdown input w-100" defaultValue="default">
                        <option disabled value="default">Please select an office</option>
                        <option value="Brisbane">Brisbane</option>
                        <option value="Sydney">Sydney</option>
                    </select>
                </div>
            </div>

            <div className="w-50 m-100 flex flex-wrap mt20">
                <label className="uppercase mb10" htmlFor="Preferred Solicitor">Preferred Solicitor</label>
                <div className="dropdown-wrapper w-100">
                    <select name="Preferred Solicitor" className="dropdown input w-100" defaultValue="default">
                        <option disabled value="default">Please select a solicitor</option>
                        <option value="No preference">No preference</option>
                        {solicitors.map(name => <option key={name} value={name}>{name}</option>)}
                    </select>
                </div>
            </div>

            <div className="flex flex-wrap mt20 w-100">
                <label className="uppercase mb10" htmlFor="howContacted">How would you like to be contacted?</label>
                <div className="dropdown-wrapper w-100">
                    <select name="howContacted" className="dropdown input w-100" defaultValue="default">
                        <option disabled defaultValue value="default">Please select an option</option>
                        <option value="Phone">Phone</option>
                        <option value="Email">Email</option>
                        <option value="Phone & Email">Phone & Email</option>
                    </select>
                </div>
            </div> 
            
            <div className="flex flex-wrap mt20 w-100">
                <label className="uppercase mb10" htmlFor="hearUs">How did you hear about us?</label>
                <div className="dropdown-wrapper w-100">
                    <select name="hearUs" className="dropdown input w-100" defaultValue="default">
                        <option disabled defaultValue value="default">Please select an option</option>
                        <option value="Recommended by a friend">Recommended by a friend or colleague</option>
                        <option value="Recommended by a previous client">Recommended by a previous or current client of the firm</option>
                        <option value="Search Engine">Search engine (eg. Google search)</option>
                        <option value="Social Media">Social media (eg. Facebook or LinkedIn)</option>
                        <option value="Advertisement">Advertisement</option>
                        <option value="Other">Other</option>
                    </select>
                </div>
            </div>

            <div className="w-100 flex flex-wrap mb40 mt20">
                <label className="uppercase mb10" htmlFor="message">Your Message</label>
                <textarea placeholder='Please type your message here...' className="w-100  text-area input" name="message" type="text" id="message" />
            </div>
            <button type="submit" className="button black mla">Submit</button>

        </form>
    )}else{
      return <div className="form-section t-pl20 thank-you" id="thank-you"> Thank You for submitting</div>
    }
  }
}

export default EnquiryForm
